export enum BrandIntegrationType {
  UNSET_INTEGRATION_TYPE, // Do not use, needed because of proto3 limitations
  BRANDVNO,
  TYPEC_MBB,
  TYPEC_HBB,
}
